export { default as BannersWithActions } from './BannersWithActions.container'
